import { combineReducers } from 'redux';
import {
  SET_NAVIGATION_MENU,
  SET_NAVIGATION_STYLE,
  SET_NAVIGATION_TEXT_COLOR,
  SET_NAVIGATION_TEXT_HOVER_COLOR,
  SET_NAVIGATION_ACCENT_COLOR,
} from '../actions/action-names';

const menu = (state = '', action) => {
  switch (action.type) {
    case SET_NAVIGATION_MENU:
      return action.value;
    default:
      return state;
  }
};

const menus = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const style = (state = '', action) => {
  switch (action.type) {
    case SET_NAVIGATION_STYLE:
      return action.value;
    default:
      return state;
  }
};

const styles = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const textColor = (state = '#0000ff', action) => {
  switch (action.type) {
    case SET_NAVIGATION_TEXT_COLOR:
      return action.value;
    default:
      return state;
  }
};

const textHoverColor = (state = '#00ff00', action) => {
  switch (action.type) {
    case SET_NAVIGATION_TEXT_HOVER_COLOR:
      return action.value;
    default:
      return state;
  }
};

const accentColor = (state = '#ff0000', action) => {
  switch (action.type) {
    case SET_NAVIGATION_ACCENT_COLOR:
      return action.value;
    default:
      return state;
  }
};

export default combineReducers({
  menu,
  menus,
  style,
  styles,
  textColor,
  textHoverColor,
  accentColor,
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/navigation-element-options-reducers.js